<template>
    <ActivityFeed
        :load="load"
        title="Team activity"
        show-actor
        empty-title="Nothing to show yet"
        empty-text="No activity yet."
    />
</template>

<script setup lang="ts">
import { homeApi } from "@/api/home";
import { useUserLookups } from "@/queries/users";
import ActivityFeed from "../activity/ActivityFeed.vue";

useUserLookups();

async function load(page: number, perPage: number) {
    return await homeApi.getActivity(page, perPage);
}

// The feed names and links each actor; consuming the user lookups resolves them.
</script>
